import React from 'react';
import { toast } from 'sonner';
import { Cookie } from '@phosphor-icons/react';
import LegalLayout from './LegalLayout';
import { COOKIE_RESET_EVENT } from '../../components/CookieBanner';

const PolitiqueCookies = () => {
  const reopenBanner = () => {
    localStorage.removeItem('ecocasse_cookie_consent_v1');
    window.dispatchEvent(new Event(COOKIE_RESET_EVENT));
    toast.success('Vos préférences ont été réinitialisées', { duration: 2500 });
  };

  return (
  <LegalLayout title="Politique de gestion des cookies" lastUpdated="01/10/2025">
    <h2>1. Qu'est-ce qu'un cookie ?</h2>
    <p>
      Un cookie est un petit fichier texte enregistré sur votre terminal (ordinateur, smartphone ou tablette) lors de la consultation d'un site internet.
    </p>
    <p>
      Il permet notamment de reconnaître un utilisateur, de mémoriser certaines préférences et de mesurer l'audience du site.
    </p>

    <h2>2. Cookies utilisés sur ce site</h2>
    <p>Le site de SARL Eco Casse peut utiliser plusieurs catégories de cookies :</p>

    <h3>Cookies strictement nécessaires</h3>
    <p>Ces cookies sont indispensables au fonctionnement du site et ne peuvent pas être désactivés.</p>
    <p>Ils permettent notamment :</p>
    <ul>
      <li>La sécurité du site ;</li>
      <li>La gestion des sessions ;</li>
      <li>Le bon affichage des pages.</li>
    </ul>

    <h3>Cookies de mesure d'audience</h3>
    <p>Avec votre accord, cette mesure permet de compter les pages consultées et d’enregistrer l’adresse IP publique du visiteur.</p>
    <p>Les données de fréquentation, y compris l’adresse IP publique, sont conservées 30 jours.</p>

    <h3>Cookies fonctionnels</h3>
    <p>Ces cookies permettent de mémoriser certaines préférences de navigation et d'améliorer votre expérience utilisateur.</p>

    <h3>Cookies publicitaires</h3>
    <p>Le cas échéant, ces cookies permettent de proposer des contenus ou publicités adaptés à vos centres d'intérêt.</p>

    <h2>3. Consentement</h2>
    <p>Lors de votre première visite, un bandeau vous informe de l'utilisation des cookies.</p>
    <p>Vous pouvez :</p>
    <ul>
      <li>Accepter tous les cookies ;</li>
      <li>Refuser les cookies non essentiels ;</li>
      <li>Personnaliser vos choix.</li>
    </ul>
    <p>Votre consentement peut être modifié à tout moment.</p>

    <h2>4. Durée de conservation</h2>
    <p>Les cookies sont conservés pour une durée maximale de 13 mois conformément aux recommandations de la CNIL.</p>

    <h2>5. Gestion des cookies</h2>
    <p>Vous pouvez à tout moment modifier vos préférences depuis l'outil de gestion du consentement disponible sur le site.</p>

    <div className="not-prose my-6 p-5 bg-[#E63946]/5 border border-[#E63946]/20 flex flex-col sm:flex-row sm:items-center gap-4">
      <Cookie size={32} className="text-[#E63946] flex-shrink-0" weight="fill" />
      <div className="flex-1">
        <p className="font-semibold text-gray-900 text-[15px]">Modifier mes préférences cookies</p>
        <p className="text-gray-600 text-sm">Cliquez pour rouvrir la bannière et ajuster votre consentement.</p>
      </div>
      <button
        onClick={reopenBanner}
        className="bg-[#E63946] text-white px-5 py-3 text-xs font-bold uppercase tracking-wide hover:opacity-90 transition-opacity whitespace-nowrap"
        data-testid="reopen-cookie-banner"
      >
        Gérer mes préférences
      </button>
    </div>

    <p>Vous pouvez également configurer votre navigateur afin de bloquer ou supprimer les cookies.</p>
    <p>Le refus de certains cookies peut toutefois affecter le fonctionnement de certaines fonctionnalités du site.</p>

    <h2>6. Contact</h2>
    <p>Pour toute question relative à l'utilisation des cookies ou à la protection de vos données personnelles, vous pouvez nous contacter :</p>
    <p>
      <strong>SARL Eco Casse</strong><br />
      1 Rue René Koechlin<br />
      67150 Gerstheim
    </p>
    <p>
      E-mail : <a href="mailto:ecocasse.careco67@gmail.com">ecocasse.careco67@gmail.com</a><br />
      Téléphone : 03 88 66 13 38
    </p>
  </LegalLayout>
  );
};

export default PolitiqueCookies;
